<template>
  <c-icon v-if="iconName" :class="classes" :size="iconSize" :icon="iconName" />

  <c-emotion v-else-if="emotion" :emotion="emotion" />

  <div v-else :class="classes" />
</template>

<script>
import CIcon from '@convenia/components/CIcon'
import CEmotion from '../CEmotion/CEmotion.vue'
/**
 * A very simple component meant to be used in bullet lists or notification badges.
 */
export default {
  name: 'CBullet',

  components: {
    CIcon,
    CEmotion
  },
  props: {
    /**
     * Changes the bg-color to our alert color (usually yellow).
     */
    alert: Boolean,
    /**
     * Changes the bg-color to our positive color (usually green).
     */
    positive: Boolean,
    /**
     * Changes the bg-color to our negative color (usually red).
     */
    negative: Boolean,
    /**
     * Changes the bg-color our alert color (usually blue)
     */
    support: Boolean,
    /**
     * Changes the bg-color our complementary color (usually orange)
     */
    complementary: Boolean,
    /**
     * Changes the bg-color our primary color (usually purple)
     */
    primary: Boolean,
    /**
     * Changes the bg-color our disabled color (usually light grey)
     */
    disabled: Boolean,
    /**
     * Changes the bullet to add a border around it.
     */
    hasBorder: Boolean,
    /**
     * The name of the icon to be displayed inside the bullet.
     * If not provided, the bullet will be a simple circle.
     */
    iconName: {
      type: String,
      default: ''
    },
    /**
     * The size of the icon to be displayed inside the bullet.
     * If not provided, the default size is 15px.
     */
    iconSize: {
      type: [ String, Number ],
      default: 15
    },
    /**
     * The emotion to be displayed inside the bullet.
     * If not provided, the bullet will be a simple circle.
     */
    emotion: {
      type: String,
      default: ''
    },
  },
  computed: {
    classes () {
      return [ 'c-bullet',
        {
          '-circle': !this.iconName,
          '-icon': this.iconName,
          '-alert': this.alert,
          '-positive': this.positive,
          '-negative': this.negative,
          '-support': this.support,
          '-complementary': this.complementary,
          '-primary': this.primary,
          '-disabled': this.disabled,
          '-has-border': this.hasBorder,
        }
      ]
    }
  }
}
</script>

<style lang="scss">
.c-bullet {
  display: inline-block;
  border-radius: 100%;
  box-sizing: content-box;

  &.-circle {
    height: 8px;
    width: 8px;
    min-height: 8px;
    min-width: 8px;
    background: color-var(primary);
  }

  &.-icon {
    height: 15px;
    width: 15px;
    min-height: 15px;
    min-width: 15px;
  }

  &.-alert.-circle {
    background: color-var(alert);
  }

  &.-positive.-circle {
    background: color-var(positive);
  }

  &.-negative.-circle {
    background: color-var(negative);
  }

  &.-support.-circle {
    background: color-var(support);
  }

  &.-primary.-circle {
    background: color-var(primary);
  }

  &.-disabled.-circle {
    background: #D0D2DA;
  }

  &.-complementary.-circle {
    background: color-var(compl-2);
  }

  &.-alert.-icon {
    @include icon-color(color-var(alert));
  }

  &.-positive.-icon {
    @include icon-color(color-var(positive));
  }

  &.-negative.-icon {
    @include icon-color(color-var(negative));
  }

  &.-support.-icon {
    @include icon-color(color-var(support));
  }

  &.-primary.-icon {
    @include icon-color(color-var(primary));
  }

  &.-disabled.-icon {
    @include icon-color(color-var(text, base-30));
  }

  &.-complementary.-icon {
    @include icon-color(color-var(compl-2));
  }

  &.-has-border {
    border: 1px solid #FBFCFB;
  }
}
</style>
